import ToastsContainer from "../../components/bonusUi/toasts";

const Toasts = () => {
  return <ToastsContainer />;
};

export default Toasts;
